import { FEATURES_FITOSGEST } from 'templates/environment.fitosgest';

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://clavei-escobi.fitosgest.com/',
    logoUrl: 'assets/logo_escobi.png',
    appName: 'escobi',
    features: {
        ...FEATURES_FITOSGEST,
        netAgroErpIntegration: true
    }
};